import { Header } from '@components/Header';
import { routes } from '@routes';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const cardClassName =
  'block rounded-lg border border-[var(--color-border)] bg-[var(--color-surface)] px-5 py-4 hover:border-[var(--color-accent)]';

export const ApiDocsHubPage = () => (
  <>
    <Helmet>
      <title>API Docs - AutoScript Admin</title>
    </Helmet>
    <Header title="API documentation" />
    <div className="mx-auto max-w-4xl px-6 py-6">
      <p className="mb-6 text-sm text-[var(--color-text-subtle)]">
        Reference documentation for the AutoScript backend APIs that are authenticated with an API key instead of a user
        session. All requests are sent to the AutoScript API base URL of the target environment and authenticated with
        the <code className="font-mono text-xs">api-key</code> HTTP header.
      </p>
      <div className="flex flex-col gap-4">
        <Link to={routes.adminApiDocsOrganizationApi.make()} className={cardClassName}>
          <h2 className="mb-1 text-base font-semibold text-[var(--color-title)]">Organization API</h2>
          <p className="text-sm text-[var(--color-text-subtle)]">
            Job creation, upload, and submission endpoints under /api/public/v1, authenticated with an Organization API
            Access Key and scoped to that organization.
          </p>
        </Link>
        <Link to={routes.adminApiDocsInternalApi.make()} className={cardClassName}>
          <h2 className="mb-1 text-base font-semibold text-[var(--color-title)]">Internal Admin API</h2>
          <p className="text-sm text-[var(--color-text-subtle)]">
            Engineer-only endpoints under /admin, authenticated with the shared INTERNAL_API_KEY and not scoped to any
            organization.
          </p>
        </Link>
      </div>
    </div>
  </>
);
